import consoleLogger from '../../../../../console-logger'
import loginPiano from '../../../../../../vendor/Piano/modules/login-piano'
import updateExperiencePiano from '../../../../../../vendor/Piano/modules/update-experience-piano'

const checkPinpollLogin = (accessToken) => {
  const [consoleLog] = consoleLogger('Pinpoll')
  consoleLog('APP Login callBack - accessToken', accessToken)
  if (!accessToken) {
    return
  }
  const isLoggedIn = loginPiano({ token: accessToken })
  if (!isLoggedIn) {
    consoleLog('APP login', 'failed')
    return
  }

  window.displayPinpoll()
  updateExperiencePiano()
}

export default checkPinpollLogin
